var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.showEmpty ? 'frame-card' : 'frame-card-hover']},[(_vm.showCard)?_c('img',{attrs:{"src":_vm.imgPath}}):_vm._e(),_vm._v(" "),(_vm.showEmptyTemp)?_c('div',{staticClass:"temp"}):_vm._e(),_vm._v(" "),(_vm.showEmptyFinished)?_c('div',{staticClass:"finished"},[_c('div',{staticClass:"center"},[_vm._v("A")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3da72390","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = null
// module chunks = 